export { default } from './Cases.container'



// WEBPACK FOOTER //
// ./src/pages/Cases/index.js